import { Pie } from 'vue-chartjs'

export default {
  extends: Pie,
  name: 'PieChart',
}
